import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Divider, Typography, CircularProgress, Checkbox, FormControlLabel, Paper } from "@material-ui/core";
import { connect } from "react-redux";
import { editInfoText } from "../../Redux/Actions/dataActions";
import axios from "axios";
import {displayDateByLanguage, formatMsToDuration } from "../../Utils/utils";



function MdlSheetEdit(props) {
  // 1. Zentraler Formular-State (Alle Felder sauber initialisiert)
  const [infoData, setInfoData] = useState({
    infoText: "",
    keySignature: "",
    tempo: 0,
    duration: "",
    instrument: "",
    youtubeLink: "",
    collection: "",
    mbId: "",       
    itunesId: "",
    category: "",     
    releaseDate: "1990-01-01",
	trackViewUrl: ""
  });

  const userLang = props.userData?.language || 'de';

  const [categories, setCategories] = useState([]);

  const [loadingApi, setLoadingApi] = useState(false);
  const [searchResults, setSearchResults] = useState([]); 
  const [selectedExternalData, setSelectedExternalData] = useState(null); 
  
  // Live-Laden der vordefinierten Admin-Kategorien (songtype)
  useEffect(() => {
    const lang = props.userData?.language || "de";
    axios.get(`/settings/options?type=songtype&lang=${lang}`)
      .then(res => { if (res.data) setCategories(res.data); })
      .catch(err => console.error("Fehler beim Laden der Kategorien:", err));
  }, [props.userData]);  
  
  
  // ⭐ Schutz-State gegen Endlosschleifen beim Tippen
  const [hasLoaded, setHasLoaded] = useState(false); 

  const [overwriteFields, setOverwriteFields] = useState({
    collection: false,
    tempo: false,
    keySignature: false,
	releaseDate: false,
	duration: false,
	category : false
  });

  // 3. Einmaliges Laden der echten Notenblatt-Daten aus der SQLite-Datenbank
  useEffect(() => {
    const sheetName = props.sheet?.safe_sheet_name || props.sheet?.safeSheetName || props.safeSheetName;
    if (!sheetName || hasLoaded) return;

    axios.get(`/sheet/${sheetName}`)
      .then(res => {
        if (res.data) {
          setInfoData({
            infoText: res.data.infoText || res.data.information_text || "",
            keySignature: res.data.keySignature || res.data.key_signature || "",
            tempo: res.data.tempo || 0,
            duration: res.data.duration || "",
            instrument: res.data.instrument || "",
            youtubeLink: res.data.youtubeLink || res.data.youtube_link || "",
            collection: res.data.collection || "",
            mbId: res.data.mbId || "",
            itunesId: res.data.itunesId || res.data.itunes_id || "",
            category: res.data.category || res.data.Category || "", 
			trackViewUrl: res.data.trackViewUrl || "",
            releaseDate: res.data.releaseDate ? res.data.releaseDate.substring(0, 10) : "1999-12-31"
          });
          setHasLoaded(true); 
        }
      })
      .catch((err) => {
        console.error("Fehler beim Live-Abruf der Formulardaten:", err);
        if (props.sheet) {
          setInfoData({
            infoText: props.sheet.infoText || "",
            keySignature: props.sheet.keySignature || "",
            tempo: props.sheet.tempo || 0,
            duration: props.sheet.duration || "",
            instrument: props.sheet.instrument || "",
            youtubeLink: props.sheet.youtubeLink || "",
            collection: props.sheet.collection || "",
            mbId: props.sheet.mbId || "",
            itunesId: props.sheet.itunesId || "",
			trackViewUrl: props.sheet.trackViewUrl || "",
            category: props.sheet.category || props.sheet.Category || "",
            releaseDate: props.sheet.releaseDate ? props.sheet.releaseDate.substring(0, 10) : "1999-12-31"
          });
        }
        setHasLoaded(true);
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.sheet?.safe_sheet_name, props.sheet?.safeSheetName, props.safeSheetName, hasLoaded]);

  const handleChange = (event) => {
    const value = event.target.name === "tempo" ? parseInt(event.target.value, 10) || 0 : event.target.value;
    setInfoData({ ...infoData, [event.target.name]: value });
  };

  // 4. Handler für normale Text-Änderungen
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInfoData(prev => {
      let updatedValue = value;
      if (name === "tempo") {
        if (value === "") {
          updatedValue = "";
        } else {
          const parsed = parseInt(value, 10);
          updatedValue = isNaN(parsed) ? "" : parsed;
        }
      }
      return { ...prev, [name]: updatedValue };
    });
  };

  // 6. Zentraler Save-Handler (Speichert erst beim Klick auf den lila Button)
  const handleSave = (e) => {
    e.preventDefault();
    const finalData = {
      ...infoData,
      tempo: infoData.tempo === "" ? 0 : Number(infoData.tempo)
    };
    props.editInfoText(finalData, props.sheet?.safe_sheet_name || props.sheet?.safeSheetName);
    props.onClose(); 
  };

  // AB HIER GEHT ES WEITER MIT: const handleFetchExternalData = async () => { ...
  const handleFetchExternalData = async () => {
    setLoadingApi(true);
    setSearchResults([]);
    setSelectedExternalData(null);
    try {
      const params = new URLSearchParams();
      if (infoData.itunesId) params.append("itunesId", infoData.itunesId);
      if (infoData.mbId) params.append("mbId", infoData.mbId);
      
//      const title = props.sheet?.sheet_name || props.sheet?.SheetName || props.sheet?.safeSheetName || "";
	  const title = props.sheet?.sheetName;
      const composer = props.sheet?.composer || props.sheet?.Composer || "";
      
      let searchTerm = title.trim();
      if (composer.trim() !== "") {
        searchTerm = `${composer.trim()} ${searchTerm}`;
      }
      params.append("term", searchTerm);

      const res = await axios.get(`/sheet/autofill?${params.toString()}`);
      
      if (res.data && Array.isArray(res.data)) {
        setSearchResults(res.data);
      }
    } catch (err) {
      console.error("Fehler beim Abrufen der externen Metadaten:", err);
    } finally {
      setLoadingApi(false);
    }
  };
  
  const handleSelectApiResult = (song) => {
    const trackIdStr = song.trackId ? String(song.trackId) : "";
    const formattedDuration = song.durationMs ? formatMsToDuration(song.durationMs) : "";

    setSelectedExternalData({
      itunes: { collectionName: song.collection || "", trackId: trackIdStr, duration: formattedDuration,  trackViewUrl: song.trackViewUrl || "", releaseDate: song.releaseDate || "", category: song.primaryGenreName || "" },
      musicbrainz: { collectionName: song.collection || "", mbId: song.mbId || "", tempo: song.tempo || 0, keySignature: song.keySignature || "", artistId: song.artistId || "" }
    });


    setInfoData(prev => ({ 
      ...prev, 
      itunesId: trackIdStr || prev.itunesId, 
      mbId: song.mbId || prev.mbId, 
	  releaseDate: song.releaseDate || prev.releaseDate,
      duration: formattedDuration || prev.duration,
	  category: song.primaryGenreName || prev.category,	  
	  trackViewUrl: song.trackViewUrl || prev.trackViewUrl,
    }));
    setSearchResults([]);

    const searchTitle = song.title || song.TrackName || "";
    const searchArtist = song.artist || song.ArtistName || "";
	
	 if (searchTitle && searchArtist) {
	  // Funktion für die automatische Wiederholung (Retry-Logik)
	  const fetchSearchDetailsWithRetry = (retriesLeft) => {
		axios.get(`/sheet/details`, { params: { title: searchTitle, artist: searchArtist } })
		  .then((res) => {
			if (res.data) {
			  const detailMbid = res.data.mbId;
			  setSelectedExternalData(prev => ({
				...prev,
				musicbrainz: {
				  ...prev.musicbrainz,
				  mbId: detailMbid,
				  tempo: res.data.bpm > 0 ? res.data.bpm : prev.musicbrainz.tempo,
				  keySignature: res.data.key || prev.musicbrainz.keySignature,
				  artistId: res.data.artistId || prev.musicbrainz.artistId
				}
			  }));
			  setInfoData(prev => ({
				...prev,
				mbId: detailMbid || prev.mbId
			  }));
			}
		  })
		  .catch((err) => {
			if (retriesLeft > 0) {
			  console.warn(`Fehler bei MB Details. Starte Versuch erneut. Verbleibende Versuche: ${retriesLeft}. Fehler:`, err);
			  
			  // 1 Sekunde (1000ms) warten vor dem nächsten Versuch
			  setTimeout(() => {
				fetchSearchDetailsWithRetry(retriesLeft - 1);
			  }, 1000);
			} else {
			  // Keine Versuche mehr übrig
			  console.error("MB Details Fehler nach 3 Wiederholungen:", err);
			}
		  });
	  };

	  // Initialer Start der Abfrage (max 3 Wiederholungen)
	  fetchSearchDetailsWithRetry(3);
	}

 
 
  };

  const handleCheckboxChange = (field) => (event) => {
    const checked = event.target.checked;
    setOverwriteFields(prev => ({ ...prev, [field]: checked }));

    if (checked && selectedExternalData) {
      setInfoData(prev => ({
        ...prev,
        collection: field === "collection" ? (selectedExternalData.itunes?.collectionName || selectedExternalData.musicbrainz?.collectionName || prev.collection) : prev.collection,
        tempo: field === "tempo" ? (selectedExternalData.musicbrainz?.tempo || prev.tempo) : prev.tempo,
        keySignature: field === "keySignature" ? (selectedExternalData.musicbrainz?.keySignature || prev.keySignature) : prev.keySignature,
        releaseDate: field === "releaseDate" ? (selectedExternalData.itunes?.releaseDate || prev.releaseDate) : prev.releaseDate,
        duration: field === "duration" ? (selectedExternalData.itunes?.duration || prev.duration) : prev.duration,
        category: field === "category" ? (selectedExternalData.itunes?.category || prev.category) : prev.category,
      }));
    }
  };
    
  return (
    <Box 
      style={{ 
        width: "100%", 
        maxWidth: "460px", 
        height: "90%",
        maxHeight: "700px",
        display: "flex", 
        flexDirection: "column",
        margin: "0 auto", 
        boxSizing: "border-box",
        overflow: "hidden"        // Verhindert, dass das Formular nach unten ausbricht
      }}
    >
      <form style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: "0" }}>
        
        {/* ⭐ SCROLL-BODY: Nimmt den gesamten Platz ein und scrollt sauber, sobald die 780px überschritten werden */}
        <Box style={{ flex: "1 1 auto", overflowY: "auto", padding: "10px 15px" }}>
          
          {/* INTERAKTIVER RECHERCHE-BEREICH */}
          <Box style={{ backgroundColor: "#f4f6f9", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "15px" }}>
            <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase" }}>
                Online-Datenabgleich
              </Typography>
              <Button 
                size="small" variant="contained" color="primary" 
                disabled={loadingApi} onClick={handleFetchExternalData}
                style={{ backgroundColor: "#4f40b3", color: "white", fontSize: "11px", textTransform: "none" }}
              >
                {loadingApi ? <CircularProgress size={14} color="inherit" /> : "Daten abrufen"}
              </Button>
            </Box>

            {searchResults.length > 0 && (
              <Box style={{ marginTop: "10px", maxHeight: "140px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "6px" }}>
                <Typography variant="caption" style={{ color: "#666" }}>Gefundene Treffer (Bitte wählen):</Typography>
                {searchResults.map((song, idx) => (
                  <Paper 
                    key={idx} variant="outlined" onClick={() => handleSelectApiResult(song)}
                    style={{ padding: "8px", cursor: "pointer", backgroundColor: "#fff" }}
                  >
                    <Typography variant="caption" style={{ display: "block", fontWeight: "bold" }}>
                      {song.title || song.TrackName || "Unbekannt"} - {song.artist || song.ArtistName || "Unbekannt"}
                    </Typography>
                    <Typography variant="caption" style={{ fontSize: "10px", color: "#777" }}>
                      Album: {song.collection || song.Collection || "Keines"}
                    </Typography>
                  </Paper>
                ))}
              </Box>
            )}

            {selectedExternalData && (
              <Box style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "10px" }}>
                <Divider />
                <Typography variant="caption" style={{ fontWeight: "bold", color: "#4f40b3" }}>Daten überschreiben?</Typography>
                
                <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                  <FormControlLabel
                    control={<Checkbox checked={overwriteFields.collection} onChange={handleCheckboxChange("collection")} color="primary" size="small" />}
                    label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Album / Collection</Typography>}
                  />
                  <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                    <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {props.sheet?.collection || props.sheet?.Collection || "keines"}</Typography>
                    <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {selectedExternalData.itunes?.collectionName || selectedExternalData.musicbrainz?.collectionName || "unbekannt"}</Typography>
                  </Box>
                </Box>

                  <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                    <FormControlLabel
                      control={<Checkbox checked={overwriteFields.tempo} onChange={handleCheckboxChange("tempo")} color="primary" size="small" />}
                      label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Tempo (BPM)</Typography>}
                    />
                    <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                      <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {infoData.tempo || "0"}</Typography>
                      <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {selectedExternalData.musicbrainz.tempo}</Typography>
                    </Box>
                  </Box>

                  <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                    <FormControlLabel
                      control={<Checkbox checked={overwriteFields.keySignature} onChange={handleCheckboxChange("keySignature")} color="primary" size="small" />}
                      label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Tonart</Typography>}
                    />
                    <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                      <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {infoData.keySignature || "keine"}</Typography>
                      <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {selectedExternalData.musicbrainz.keySignature}</Typography>
                    </Box>
                  </Box>
                  <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                    <FormControlLabel
                      control={<Checkbox checked={overwriteFields.releaseDate} onChange={handleCheckboxChange("releaseDate")} color="primary" size="small" />}
                      label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Veröffentlichung</Typography>}
                    />
                    <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                      <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {displayDateByLanguage(props.sheet?.releaseDate, userLang) || ""}</Typography>  
                      <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {displayDateByLanguage(selectedExternalData.itunes.releaseDate, userLang) || ""}</Typography>
                    </Box>
                  </Box>
                  <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                    <FormControlLabel
                      control={<Checkbox checked={overwriteFields.duration} onChange={handleCheckboxChange("duration")} color="primary" size="small" />}
                      label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Dauer</Typography>}
                    />
                    <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                      <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {props.sheet?.duration || "keine"}</Typography>
                      <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {selectedExternalData.itunes.duration}</Typography>
                    </Box>
                  </Box>	
                  <Box style={{ display: "flex", flexDirection: "column", gap: "2px", backgroundColor: "#fff", padding: "6px", borderRadius: "4px" }}>
                    <FormControlLabel
                      control={<Checkbox checked={overwriteFields.category} onChange={handleCheckboxChange("category")} color="primary" size="small" />}
                      label={<Typography variant="caption" style={{ fontWeight: "bold" }}>Kategorie</Typography>}
                    />
                    <Box style={{ display: "flex", justifyContent: "space-between", paddingLeft: "30px" }}>
                      <Typography variant="caption" style={{ color: "#cc0000" }}>Alt: {props.sheet?.category || "keine"}</Typography>
                      <Typography variant="caption" style={{ color: "#00b300" }}>Neu: {selectedExternalData.itunes.category}</Typography>
                    </Box>
                  </Box>				  
              </Box>
            )}
          </Box>

          {/* BESCHREIBUNGSTEXT */}
          <Box style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "15px" }}>
            <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase" }}>
              Beschreibungstext
            </Typography>
            <TextField
              fullWidth variant="outlined" size="small" label="Information Text" name="infoText"
              multiline minRows={3} value={infoData.infoText} onChange={handleInputChange}
            />
          </Box>

          <Divider style={{ margin: "10px 0" }} />

          {/* EIGENSCHAFTEN & IDS */}
          <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Typography variant="caption" style={{ color: "#4f40b3", fontWeight: "bold", textTransform: "uppercase" }}>
              Musikalische Eigenschaften & IDs
            </Typography>

            <TextField fullWidth variant="outlined" size="small" label="Tonart" name="keySignature" value={infoData.keySignature} onChange={handleInputChange}/>
            <TextField fullWidth variant="outlined" size="small" type="number" label="Tempo (BPM)" name="tempo" value={infoData.tempo === 0 ? "" : infoData.tempo} onChange={handleInputChange}/>
            <TextField fullWidth variant="outlined" size="small" label="Dauer" name="duration" value={infoData.duration} onChange={handleInputChange} />
            <TextField fullWidth variant="outlined" size="small" label="Instrument" name="instrument" value={infoData.instrument} onChange={handleInputChange} />
            <TextField fullWidth variant="outlined" size="small" label="Album / Collection" name="collection" value={infoData.collection} onChange={handleInputChange} />
            <TextField fullWidth variant="outlined" size="small" label="YouTube Video Link" name="youtubeLink" value={infoData.youtubeLink} onChange={handleInputChange} />
            <TextField fullWidth variant="outlined" size="small" label="Apple iTunes ID" name="itunesId" value={infoData.itunesId} onChange={handleInputChange} />
            <TextField fullWidth variant="outlined" size="small" label="MusicBrainz ID (MBID)" name="mbId" value={infoData.mbId} onChange={handleInputChange} />
          </Box>

          <Divider style={{ margin: "10px 0" }} />

          {/* Natives Kategorie-Dropdown */}
          <Box display="flex" flexDirection="column" style={{ gap: "16px" }}>
            <Typography variant="caption" style={{ color: "#757575", fontWeight: "600", marginLeft: "4px" }}>
              Kategorie / Genre (Feste Liste)
            </Typography>
            <select
              name="category"
              value={infoData.category}
              onChange={handleChange}
              style={{
                width: "100%", padding: "10px 14px", borderRadius: "4px", borderColor: "#c4c4c4",
                backgroundColor: "white", fontSize: "15px", fontFamily: "inherit", color: "#1d1b31",
                cursor: "pointer", outline: "none"
              }}
            >
              <option value="">Keine feste Kategorie</option>
              {categories && categories.map((cat) => (
                <option key={cat.id || cat.value} value={cat.value}>{cat.value}</option>
              ))}
            </select>
          </Box>

		</Box>


        {/* ⭐ STICKY-FOOTER: Sitzt bombenfest am unteren Rand deiner 780px-CSS-Box */}
        <Box 
          style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            gap: "12px", 
            padding: "12px 15px", 
            backgroundColor: "#fff", 
            borderTop: "1px solid #e0e0e0",
            flexShrink: 0
          }}
        >
          <Button type="button" variant="outlined" onClick={props.onClose} style={{ borderRadius: "8px", textTransform: "none" }}>Cancel</Button>
          <Button type="button" onClick={handleSave} variant="contained" style={{ borderRadius: "8px", backgroundColor: "#4f40b3", color: "white", textTransform: "none" }}>
            Save Info Box
          </Button>
        </Box>
      </form>
    </Box>
  );
}

const mapActionsToProps = { editInfoText };
export default connect(null, mapActionsToProps)(MdlSheetEdit);